import * as tslib_1 from "tslib";
import { getMrsConnectedAccounts } from '../services/getMrsConnectedAccounts';
import { resetConnectedFullStore } from '../actions/connectedFull/resetConnectedFullStore';
export function loadMrsConnectedAccounts() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMrsConnectedAccounts()];
                case 1:
                    response = _a.sent();
                    resetConnectedFullStore(response.ErrorMessage ? null : response.ConnectedAccountsInformation);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadMrsConnectedAccounts.js.map